// extracted by mini-css-extract-plugin
module.exports = {"SM":"360px","MD":"640px","LG":"1200px","Root":"Modal_Root__2sMs-","Title":"Modal_Title__2jLvI","Close":"Modal_Close__39DVn"};